import type { ReactElement } from 'react';
import { AboutHeroMedia } from './about-hero-media';

interface AboutHeroProps {
  readonly imageUrl: string | null;
  readonly isImagePending: boolean;
}

/**
 * 회사 소개 첫 화면 — 큰 영문 "About" 제목(보조기기에는 "회사 소개"), 한 줄 선언과 소개 문단,
 * 그 아래 전폭 사진 칸. 문구는 서비스 개요(디자인 → 견적 → 상담 → 확정견적 → 주문·제작·배송)만 근거로 한다.
 */
export const AboutHero = ({ imageUrl, isImagePending }: AboutHeroProps): ReactElement => (
  <section aria-labelledby="about-heading" className="flex flex-col gap-10 sm:gap-14">
    <header className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between lg:gap-16">
      <div className="flex flex-col gap-6">
        <p className="flex items-center gap-3 text-[13px] font-semibold tracking-[0.18em] text-muted-foreground">
          <span aria-hidden className="block h-px w-10 bg-brand-lime" />
          SUPERSTRUCTURE
        </p>
        <h1
          id="about-heading"
          className="text-[clamp(2.5rem,5vw,4.5rem)] leading-none font-bold tracking-[-0.03em]"
        >
          <span aria-hidden>About</span>
          <span className="sr-only">회사 소개</span>
        </h1>
        <p className="text-[clamp(1.75rem,3.4vw,3rem)] leading-[1.25] font-semibold tracking-[-0.03em] text-balance">
          브랜드를 담은 굿즈,
          <br />
          디자인부터 배송까지 한곳에서.
        </p>
      </div>
      <p className="max-w-md text-[15px] leading-relaxed text-muted-foreground sm:text-base lg:pb-2">
        슈퍼스트럭처는 기업·단체를 위한 커스터마이징 굿즈 제작 플랫폼입니다. 상품 사진 위에서 직접
        디자인하고, 상담으로 견적을 확정한 뒤 주문마다 제작해 보내 드립니다.
      </p>
    </header>

    <AboutHeroMedia imageUrl={imageUrl} isPending={isImagePending} />
  </section>
);
